export default __webpack_public_path__ + "static/media/snow.8b1ce55b.jpg";